import { createPortal } from 'react-dom';
import FlameIcon from './FlameIcon';
import { getLevelColor } from './useLevelLadder';
import {
	TemperatureBackdrop,
	TemperatureClose,
	TemperatureDetailsHeader,
	TemperatureDetailsModal,
	TemperatureDetailsTitle,
	TemperatureFactorBar,
	TemperatureFactorFill,
	TemperatureFactorIcon,
	TemperatureFactorLabel,
	TemperatureFactorRow,
	TemperatureFactors,
	TemperatureFactorValue,
	TemperatureLevelHeading,
	TemperatureLevelItem,
	TemperatureLevelName,
	TemperatureLevels,
	TemperatureProgressLabel,
	TemperatureProgressTrack,
	TemperatureSep,
	TemperatureSubtitle,
} from './chatSelectedProfile.styles';

const TemperatureDetailsDialog = ({
	t,
	accentColor,
	flameLevels,
	litCount,
	levelName,
	progressPercent,
	progressLabel,
	factorRows,
	highestFactorScore,
	onClose,
}) =>
	createPortal(
		<TemperatureBackdrop role="presentation" onClick={onClose}>
			<TemperatureDetailsModal
				role="dialog"
				aria-modal="true"
				aria-labelledby="temperature-details-title"
				onClick={(event) => event.stopPropagation()}
				$color={accentColor}
			>
				<TemperatureClose
					type="button"
					onClick={onClose}
					aria-label={t.close}
					$color={accentColor}
				>
					×
				</TemperatureClose>
				<TemperatureDetailsHeader>
					<TemperatureDetailsTitle id="temperature-details-title">
						{t.conversationTemperature}
					</TemperatureDetailsTitle>
					<TemperatureSubtitle>{t.temperatureSubtitle}</TemperatureSubtitle>
				</TemperatureDetailsHeader>
				<TemperatureLevels $count={flameLevels.length || 1}>
					{flameLevels.map((level, index) => (
						<TemperatureLevelItem
							key={level.id || level.name || `level-${index}`}
							$active={index < litCount}
							$color={getLevelColor(level, accentColor)}
						>
							<FlameIcon
								lit={index < litCount}
								size="lg"
								color={getLevelColor(level, accentColor)}
							/>
							<TemperatureLevelName>{level.name}</TemperatureLevelName>
						</TemperatureLevelItem>
					))}
				</TemperatureLevels>
				<TemperatureLevelHeading $color={accentColor}>
					{(t.levelNumberLabel || 'Poziom {number} · {name}')
						.replace('{number}', String(Math.max(litCount, 1)))
						.replace('{name}', levelName)}
				</TemperatureLevelHeading>
				<TemperatureProgressTrack $color={accentColor}>
					<span style={{ width: `${progressPercent}%` }} />
				</TemperatureProgressTrack>
				<TemperatureProgressLabel>{progressLabel}</TemperatureProgressLabel>
				<TemperatureSep $color={accentColor}>
					<span>{t.whatRaisesTemperature}</span>
				</TemperatureSep>
				<TemperatureFactors>
					{factorRows.map((factor) => {
						const fillPercent = Math.round(
							(factor.value / highestFactorScore) * 100,
						);

						return (
							<TemperatureFactorRow key={factor.key}>
								<TemperatureFactorIcon $tone={factor.tone}>
									{factor.icon}
								</TemperatureFactorIcon>
								<TemperatureFactorLabel>{factor.name}</TemperatureFactorLabel>
								<TemperatureFactorValue>{fillPercent}</TemperatureFactorValue>
								<TemperatureFactorBar>
									<TemperatureFactorFill
										$tone={factor.tone}
										style={{ width: `${fillPercent}%` }}
									/>
								</TemperatureFactorBar>
							</TemperatureFactorRow>
						);
					})}
				</TemperatureFactors>
			</TemperatureDetailsModal>
		</TemperatureBackdrop>,
		document.body,
	);

export default TemperatureDetailsDialog;
